import { createModel } from "@rematch/core";
import * as _ from "lodash";
import { CustomerType, EffectsDataState } from "src/types";

import * as api from "../api";
import { RootModel } from ".";
import { checkToken, multiRequest, signoutIfUnauthorized } from "./utilities";

const initialState: EffectsDataState = {
  effectsData: [],
  loading: false,
  pending: null,
};

export const effectsData = createModel<RootModel>()({
  state: initialState as EffectsDataState,
  reducers: {
    fetchPending(state, requestId: string) {
      return multiRequest.updatePending(state, requestId);
    },
    fetchSuccess(
      state,
      payload: Array<{
        column_name: string;
        effect: string;
        affected_rows: number;
        column_value: string;
        target_name: string;
        customer_type: string;
      }>,
      requestId: string
    ) {
      return multiRequest.updateSuccess(
        { effectsData: payload },
        state,
        requestId
      );
    },
    fetchFail(state, requestId: string) {
      return multiRequest.updateFail(state, requestId);
    },
  },
  effects: (dispatch) => ({
    async fetchEffectsData(
      {
        customerType,
        columnName,
      }: { customerType: CustomerType; columnName?: string },
      rootState
    ) {
      if (!columnName) {
        return;
      }

      const columnsData = _.filter(
        rootState.effectsColumnsData.effectsColumnsData,
        (item) => item.columnName === columnName
      );

      if (columnsData.length === 0) {
        return;
      }

      const requestId = multiRequest.getRequestId();
      dispatch.effectsData.fetchPending(requestId);

      const token = checkToken(rootState, () =>
        dispatch.effectsData.fetchFail(requestId)
      );
      if (!token) return;

      try {
        const effectsDataResult = await api.fetchEffects(
          token,
          columnsData[0].columns,
          customerType
        );
        dispatch.effectsData.fetchSuccess(effectsDataResult.data, requestId);
      } catch (error) {
        signoutIfUnauthorized(error, dispatch);
        dispatch.effectsData.fetchFail(requestId);
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
  }),
});



// WEBPACK FOOTER //
// ./src/models/effectsData.ts